import { getMemberStores } from "@/services/api.service";

export default {
    namespaced: true,
    state: {
        stores: [],
        page: 1,
        pageSize: 10,
        totalCount: 0,
    },
    getters: {
        storeList: (state) => state.stores,
        totalCount: (state) => state.totalCount,
        hasMoreStores: (state) => state.page !== -1,
    },
    mutations: {
        setStores(state, stores) {
            state.stores = stores;
        },
        appendStores(state, stores) {
            const merged = [...state.stores, ...stores];
            // 相同 store_code 只保留一筆
            const seen = new Set();
            state.stores = merged.filter((item) => {
                if (seen.has(item.store_code)) return false;
                seen.add(item.store_code);
                return true;
            });
        },
        setPage(state, page) {
            state.page = page;
        },
        setTotalCount(state, totalCount) {
            state.totalCount = totalCount;
        },
        resetStores(state) {
            state.stores = [];
            state.page = 1;
            state.totalCount = 0;
        },
    },
    actions: {
        async fetchMemberStores({ commit, state, rootGetters }) {
            if (state.page === -1) return;
            const sendData = {
                // access_token  = LINE access token（liff.getAccessToken）
                // line_id_token = LINE ID token（liff.getIDToken）
                access_token: rootGetters['line/accessToken'],
                line_id_token: rootGetters['line/idToken'],
                page: state.page,
                page_size: state.pageSize,
            };
            const res = await getMemberStores(sendData);
            if (res?.data?.data?.msg === 'Failed') {
                throw res?.data?.data?.err_msg;
            }
            const data = res?.data?.data || {};
            const list = data.member_stores_info_list ?? [];
            commit('appendStores', list);
            commit('setTotalCount', data.total_count ?? 0);
            list.length < state.pageSize
                ? commit('setPage', -1)
                : commit('setPage', state.page + 1);
        },
    },
};
